import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  return;
}